import React from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { InputAdornment, TextField, Tooltip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

interface PlannerFieldProps {
    parentClasses: ClassNameMap,
    setValue: any,
    value: string,
    labelText: string,
    lastElement?: boolean,
    description: string,
    readonly:boolean,
}

const PlannerField: React.FC<PlannerFieldProps> = ({
    parentClasses,
    setValue,
    value,
    labelText,
    lastElement,
    description,
    readonly
}) => {
    console.log(readonly)
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    return (
        <div className={parentClasses.inputRow}>
            <div className={parentClasses.labelText}>
                {labelText}
                <span>
                    <Tooltip title={description}>
                        <InfoOutlinedIcon className={parentClasses.labelIcon} />
                    </Tooltip>
                </span>
            </div>
            <div className={parentClasses.selectField}>
                <TextField
                    InputProps={{
                        classes: { root: parentClasses.textFieldInput },
                        endAdornment: <InputAdornment position="end">Minutes</InputAdornment>,
                        disabled:readonly
                    }}
                    
                    variant='outlined'
                    type="number"
                    value={value}
                    onChange={handleChange}
                />
            </div>
        </div>
    );
}

export default PlannerField;